import React, { useState } from "react";

const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    country: "",
    email: "sharmisharmila879@gmail.com",
    mobile: "9876543210",
  });
  const [profileImage, setProfileImage] = useState(
    "https://via.placeholder.com/50"
  ); // Default profile picture

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log("File selected:", file); // Debugging log
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      console.log("No file selected");
    }
  };

  const handleImageClick = () => {
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.click();
    } else {
      console.error("File input not found");
    }
  };

  return (
    <div className="bg-white min-h-screen p-6 md:p-10 lg:p-16 max-w-4xl mx-auto mt-10  ">
      <div className="flex justify-end mb-6">
        <button
          onClick={() => setIsEditing(!isEditing)}
          className="bg-black text-white font-medium px-6 py-2 rounded-full hover:bg-gray-800"
        >
          {isEditing ? "Save" : "Edit"}
        </button>
      </div>
      
      <div className="flex items-center mb-6 relative">
        <img
          src={profileImage}
          alt="Profile"
          className="w-24 h-24 rounded-full mr-4 object-cover"
        />
        {isEditing && (
          <>
            <div className="absolute left-16 bottom-0 w-8 h-8 bg-black text-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-800">
              <button onClick={handleImageClick}>+</button>
            </div>
            <input
              type="file"
              id="fileInput"
              accept="image/*"
              onChange={handleImageChange}
              className="hidden"
            />
          </>
        )}

        <div>
          <p className="text-xl font-semibold text-gray-900">Sharmila Sharma</p>
          <p className="text-sm text-gray-600">{profile.email}</p>
        </div>
      </div>

      <form>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 font-semibold">First Name</label>
            <input
              type="text"
              name="firstName"
              value={profile.firstName}
              onChange={handleChange}
              disabled={!isEditing}
              className={`mt-2 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-black transition-all ${
                isEditing
                  ? "bg-white border-gray-300"
                  : "bg-gray-100 border-transparent"
              }`}
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold">Last Name</label>
            <input
              type="text"
              name="lastName"
              value={profile.lastName}
              onChange={handleChange}
              disabled={!isEditing}
              className={`mt-2 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-black transition-all ${
                isEditing
                  ? "bg-white border-gray-300"
                  : "bg-gray-100 border-transparent"
              }`}
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold">Gender</label>
            <select
              name="gender"
              value={profile.gender}
              onChange={handleChange}
              disabled={!isEditing}
              className={`mt-2 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-black transition-all ${
                isEditing
                  ? "bg-white border-gray-300"
                  : "bg-gray-100 border-transparent"
              }`}
            >
              <option value="" disabled>
                Select Gender
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
          <div>
            <label className="block text-gray-700 font-semibold">Country</label>
            <input
              type="text"
              name="country"
              value={profile.country}
              onChange={handleChange}
              disabled={!isEditing}
              className={`mt-2 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-black transition-all ${
                isEditing
                  ? "bg-white border-gray-300"
                  : "bg-gray-100 border-transparent"
              }`}
            />
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-gray-700 font-semibold">Email Address</label>
          <input
            type="email"
            name="email"
            value={profile.email}
            disabled
            className="mt-2 w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md text-gray-700"
          />
        </div>

        <div className="mt-6">
          <label className="block text-gray-700 font-semibold">Mobile Number</label>
          <input
            type="tel"
            name="mobile"
            value={profile.mobile}
            disabled
            className="mt-2 w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md text-gray-700"
          />
        </div>
      </form>
    </div>
  );
};

export default Profile;
